import React from "react";
import { Quote } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/common/Reveal";
import SectionLabel from "@/components/common/SectionLabel";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-gema-ink py-24 md:py-32 border-t border-white/5">
      <div className="container-gema">
        <Reveal>
          <SectionLabel index="06">Testimonios</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="heading-lg text-white mt-6 max-w-3xl">La confianza de nuestros clientes</h2>
        </Reveal>

        <RevealGroup className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
          {TESTIMONIALS.map((t, i) => (
            <RevealItem key={i}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full border border-white/10 bg-gema-black p-8 flex flex-col transition-colors duration-300 hover:border-gema-red/40"
              >
                <Quote className="h-8 w-8 text-gema-red" />
                <blockquote className="text-white/80 leading-relaxed mt-6 flex-1">"{t.quote}"</blockquote>
                <figcaption className="mt-8 pt-6 border-t border-white/10">
                  <p className="font-heading font-bold uppercase text-sm text-white">{t.author}</p>
                  <p className="text-white/40 text-xs mt-1">{t.role}</p>
                </figcaption>
              </figure>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
